export default "__VITE_ASSET__tpoYyHEL__"